import { FormattedMessage } from 'react-intl'
import {
  CONDITION,
  type Conditions as ConditionsType,
  type DefaultProps,
} from 'typings'
import { SummaryRow, TagsList } from 'ui'
import { Affiliates } from './Affiliates'
import { Bin } from './Bin'
import { Cluster } from './Cluster'
import { FirstPurchase } from './FirstPurchase'
import { HistoricalPurchaseValue } from './HistoricalPurchaseValue'
import { Installments } from './Installments'
import { ItemPriceRange } from './ItemPriceRange'
import { ListPrice } from './ListPrice'
import { MarketingTags } from './MarketingTags'
import { messages } from './messages'
import { OrderValue } from './OrderValue'
import { PaymentMethods } from './PaymentMethods'
import { ShippingLocation } from './ShippingLocation'
import { ShippingMethods } from './ShippingMethods'
import { Subscription } from './Subscription'
import { UTM } from './UTM'
import { UTMICampaign } from './UTMICampaign'

export type ConditionsProps = DefaultProps & {
  conditions: ConditionsType
  key?: string
}

const componentsMap = {
  [CONDITION.PAYMENT_METHODS]: PaymentMethods,
  [CONDITION.BIN]: Bin,
  [CONDITION.ORDER_VALUE]: OrderValue,
  [CONDITION.ITEM_PRICE_RANGE]: ItemPriceRange,
  [CONDITION.CLUSTER]: Cluster,
  [CONDITION.UTM]: UTM,
  [CONDITION.SHIPPING_LOCATION]: ShippingLocation,
  [CONDITION.SHIPPING_METHODS]: ShippingMethods,
  [CONDITION.LIST_PRICE]: ListPrice,
  [CONDITION.INSTALLMENTS]: Installments,
  [CONDITION.AFFILIATES]: Affiliates,
  [CONDITION.HISTORICAL_PURCHASE_VALUE]: HistoricalPurchaseValue,
  [CONDITION.MARKETING_TAGS]: MarketingTags,
  [CONDITION.FIRST_PURCHASE]: FirstPurchase,
  [CONDITION.SUBSCRIPTION]: Subscription,
  [CONDITION.UTMI_CAMPAIGN]: UTMICampaign,
}

export function ConditionsRow(props: ConditionsProps) {
  const { conditions } = props

  const hasConditions = Object.values(conditions).some((c) => c)

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.title} />
      </SummaryRow.Title>
      <SummaryRow.Value>
        {hasConditions ? (
          <TagsList>
            {Object.entries(conditions)
              .filter((entry) => !!entry)
              .map(([key, value], index) => {
                const Component = componentsMap[key]

                const props = { [key]: value }
                //@ts-expect-error missing required params
                return Component ? <Component {...props} key={index} /> : null
              })}
          </TagsList>
        ) : (
          <FormattedMessage {...messages.empty} />
        )}
      </SummaryRow.Value>
    </SummaryRow>
  )
}
